// import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import { AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'

export const SaveQuoteMixin = {
  // Using beforeRouterEnter instead of created or any vue lifecycle because
  // Using vue lifecycle does not guarantee components are created before previous components are destroyed (the way how vue router deals with routing/lifecycle)
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // It listens to global event hub on event
      // It calls the page that listen to this to initiate doPartialSave
      // all quotation/proposal page should have this method (even if it is empty)
      vm.$root.$on('saveQuote', (toExit = false) => {
        vm.doPartialSave()
          .then((response) => {
            if (response === true && toExit) {
              vm.$root.$emit('leaveQuote')
            }
          })
      })

      // For NTU/Void, do save before calling individual method
      vm.$root.$on('ntu', () => {
        vm.doPartialSave()
          .then((response) => {
            if (response === true) {
              // Do NTU
              store.dispatch('ntuQuote')
                .then((ntuResponse) => {
                  // Vue.prototype.$snotify.success('Quotation status changed to Not Taken Up')
                  store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
                  if (store.state.agency.quotation.commonForm.appID === 'MO') {
                    router.push({ name: 'motorQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'CA') {
                    router.push({ name: 'cargoQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'TR') {
                    router.push({ name: 'travelQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'PK') {
                    router.push({ name: 'packageQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'FI') {
                    router.push({ name: 'fireQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'MD') {
                    router.push({ name: 'cargoQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  }
                })
            }
          })
      })
      vm.$root.$on('void', () => {
        vm.doPartialSave()
          .then((response) => {
            if (response === true) {
              // Do Void
              store.dispatch('voidQuote')
                .then((voidResponse) => {
                  // Vue.prototype.$snotify.success('Quotation status changed to Void')
                  store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
                  if (store.state.agency.quotation.commonForm.appID === 'MO') {
                    router.push({ name: 'motorQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'CA') {
                    router.push({ name: 'cargoQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'TR') {
                    router.push({ name: 'travelQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'PK') {
                    router.push({ name: 'packageQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'FI') {
                    router.push({ name: 'fireQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  } else if (store.state.agency.quotation.commonForm.appID === 'MD') {
                    router.push({ name: 'cargoQuoteQuery', params: { id: store.state.agency.quotation.commonForm.proposalNo } })
                  }
                })
            }
          })
      })
    })
  },
  // Not using vue router lifecycle (beforeRouteLeave) here because leaveQuote is using that lifeCycle to do its init work
  beforeDestroy() {
    this.$root.$off('saveQuote')
    this.$root.$off('ntu')
    this.$root.$off('void')
  }
}
